module.exports = "/lucky-balls/img/combos-sr/28.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos-sr/28.png
// module id = 989
// module chunks = 0